import ClientNavbar from "../../Client/ClientLayout/ClientNavbar.js";
import ClientFooter from "../../Client/ClientLayout/ClientFooter.js";
import Form from "react-bootstrap/Form";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  CardHeader,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../Constant.js";
import fetchWithAuth from "../../../fetchWithAuth.js";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PatientDetails = () => {
  const navigate = useNavigate();
  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // Convert to 'YYYY-MM-DD' format
  };

  const [firstName, setFirstName] = useState(localStorage.getItem("firstName"));
  const [lastName, setLastName] = useState(localStorage.getItem("lastName"));
  const [mobileNo, setMobileNo] = useState(localStorage.getItem("mobileno"));
  const [emailId, setEmailId] = useState(localStorage.getItem("emailId"));
  const [birthdate, setBirthdate] = useState(formatDate(new Date()));
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPinCode] = useState("");
  const [maritalStatusesList, setMaritalStatusesList] = useState([]);
  const [maritalStatusId, setMaritalStatusId] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [countryId, SetCountryId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [stateId, setStateId] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [subcategoryList, setSubCategoryList] = useState([]);
  const [subCategoryId, setSubCategoryId] = useState(0);
  const [showTextbox, setShowTextbox] = useState(false); // State for textbox visibility
  const [othercategorytext, setothercategorytext] = useState(null);

  const [birthdateError, setBirthdateError] = useState("");
  const [genderError, setGenderError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [maritalStatusError, setMaritalStatusError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [otherCategoryTextError, setOtherCategoryTextError] = useState("");
  const validateForm = () => {
    let isValid = true;

    if (!birthdate) {
      setBirthdateError("* Birthdate is required");
      isValid = false;
    } else {
      setBirthdateError("");
    }

    if (!gender) {
      setGenderError("* Please select Gender");
      isValid = false;
    } else {
      setGenderError("");
    }

    if (!maritalStatusId) {
      // Should check maritalStatusId, not the whole list
      setMaritalStatusError("* Please select Marital Status");
      isValid = false;
    } else {
      setMaritalStatusError("");
    }

    if (!countryId) {
      // Should check countryId
      setCountryError("* Please select Country");
      isValid = false;
    } else {
      setCountryError("");
    }

    if (!stateId) {
      // Should check stateId
      setStateError("* Please select State");
      isValid = false;
    } else {
      setStateError("");
    }

    if (!address.trim()) {
      setAddressError("* Please enter Address");
      isValid = false;
    } else {
      setAddressError("");
    }

    if (!pincode.trim()) {
      setPincodeError("* Please enter Pincode");
      isValid = false;
    } else {
      setPincodeError("");
    }

    if (!categoryId) {
      // Should check categoryId
      setCategoryError("* Please select Category");
      isValid = false;
    } else {
      setCategoryError("");
    }

    return isValid; // Return the validation result
  };
  const handleDropdownChangeGender = (e) => {
    const { value } = e.target;
    setGender(value);
  };

  const handleDropdownChangeMarital = (e) => {
    const { value } = e.target;
    setMaritalStatusId(value);
  };

  const handleDropdownChangeCountry = (e) => {
    const { value } = e.target;
    SetCountryId(value);
    fetchStatesCountrywise(value);
  };

  const handleDropdownChangeState = (e) => {
    const { value } = e.target;
    setStateId(value);
  };

  const handleDropdownChangeCategory = (e) => {
    const { value } = e.target;
    console.log(value);

    setCategoryId(value);

    fetchSubCategories(value);

    const selectedCategory = categoryList.find(
      (category) => category.categoryId == value
    );

    if (selectedCategory?.patientCategory === "Others") {
      setShowTextbox(true);
    } else {
      setShowTextbox(false);
    }
  };

  const handleDropdownChangeSubCategory = (e) => {
    const { value } = e.target;
    console.log(value);
    setSubCategoryId(value);
  };

  useEffect(() => {
    // Fetch marital statuses from API
    fetchMaritalStatus();
    fetchCountries();
    fetchCategories();
  }, []);

  const fetchMaritalStatus = async () => {
    try {
      const response = await fetch(`${API_URL}Masters/GetMaritalStatusList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setMaritalStatusesList(result.data || []);
    } catch (error) {
      console.error("Error fetching marital status:", error);
      return [];
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await fetch(`${API_URL}Masters/GetCountryList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setCountryList(result.data || []);
    } catch (error) {
      console.error("Error fetching marital status:", error);
      return [];
    }
  };

  const fetchStatesCountrywise = async (countryId) => {
    try {
      const response = await fetch(
        `${API_URL}Masters/GetStateList/${countryId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setStateList(result.data || []);
    } catch (error) {
      console.error("Error fetching marital status:", error);
      return [];
    }
  };

  const fetchCategories = async (countryId) => {
    try {
      const response = await fetch(`${API_URL}Masters/GetPatientCategoryList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setCategoryList(result.data || []);
    } catch (error) {
      console.error("Error fetching marital status:", error);
      return [];
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await fetch(
        `${API_URL}Masters/GetSubPatientCategoryList/${categoryId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Roles. Status: " + response.status);
      }
      const result = await response.json();
      setSubCategoryList(result.data || []);
    } catch (error) {
      console.error("Error during Roles fetching:", error.message);
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    console.log(categoryId);

    const data = {
      loginId: localStorage.getItem("loginId"),
      firstName: firstName,
      lastName: lastName,
      mobileNo: mobileNo,
      emailId: emailId,
      dateOfBirth: birthdate,
      gender: gender,
      maritalStatusId: maritalStatusId,
      countryId: countryId,
      stateId: stateId,
      streetAdderess: address,
      pincode: pincode,
      patientCategoryId: categoryId,
      subCategoryId: subCategoryId,
      otherCategory: othercategorytext,
      createdOn: new Date().toISOString(),
      isDeleted: false,
      updatedOn: new Date().toISOString(),
      updatedBy: 0,
    };

    console.log(data);

    try {
      const response = await fetch(API_URL + "api/Client/SavePatientDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Patient Saved Successfully");

        console.log("Patient Saved Successfully:", result);

        // Redirect to /client/cancerDetails
        navigate("/client/cancerDetails");
      } else {
        toast.error("Failed to create account. Please try again.");
        const errorText = await response.text();
        console.error("Error during save:", errorText);
      }
    } catch (error) {
      console.error("Error during save:", error);
      toast.error("An error occurred while saving patient details.");
    }

    // Reset form fields after successful submission
    setFirstName("");
    setLastName("");
    setMobileNo("");
    setEmailId("");
    setBirthdate("");
    setGender("");
    setMaritalStatusId("");
    SetCountryId("");
    setStateId("");
    setAddress("");
    setPinCode("");
    setCategoryId("");
    setSubCategoryId("");
  };
  const handleCancel = () => {
    setBirthdate("");
    setGender("");
    SetCountryId("");  
    setMaritalStatusId("");
    setStateId("");
    setAddress("");
    setPinCode("");
    setCategoryId("");
    setothercategorytext("");
  
    setBirthdateError("");
    setGenderError("");
    setCountryError("");
    setMaritalStatusError("");
    setStateError("");
    setAddressError("");
    setPincodeError("");
    setCategoryError("");
    setOtherCategoryTextError("");  
  };
  return (
    <div>
      <ClientNavbar />
      <Card
        style={{
          width: "700px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid gray",
          borderRadius: "10px",
          marginLeft: "26%",
          padding: "20px",
        }}
      >
        <Card.Body>
          <Card.Text>
            <center>
              <h2>Patient Personal Details</h2>
            </center>
            <hr />
            <Form>
              <Form.Group className="mb-3" controlId="formFirstName">
                <Form.Label>
                  First Name <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFirstName(value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formLastName">
                <Form.Label>
                  Last Name <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLastName(value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMobileNo">
                <Form.Label>
                  Mobile No <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Mobile No"
                  value={mobileNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    setMobileNo(value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmailId">
                <Form.Label>
                  EmailId <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="EmailId"
                  value={emailId}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmailId(value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBirthdate">
                <Form.Label>
                  Birth Date <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Birth Date"
                  value={birthdate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBirthdate(value);
                    setBirthdateError(value ? "" : "Birthdate is required");
                  }}
                />
                {birthdateError && (
                  <div style={{ color: "red", fontSize: "0.9em" }}>
                    {birthdateError}
                  </div>
                )}
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3" controlId="formgender">
                    <Form.Label>
                      Gender <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Select
                      value={gender}
                      onChange={(e) => {
                        handleDropdownChangeGender(e);
                        setGenderError(
                          e.target.value ? "" : "Gender is required"
                        );
                      }}
                      className="form-control"
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                    {genderError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {genderError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formCountryList">
                    <Form.Label>
                      Country <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Select
                      value={countryId}
                      onChange={(e) => {
                        handleDropdownChangeCountry(e);
                        setCountryError(
                          e.target.value ? "" : "Country is required"
                        );
                      }}
                      className="form-control"
                    >
                      <option value="">Select Country</option>
                      {countryList.map((status) => (
                        <option key={status.countryId} value={status.countryId}>
                          {status.countryName}
                        </option>
                      ))}
                    </Form.Select>
                    {countryError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {countryError}
                      </div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3" controlId="formMaritalStatus">
                    <Form.Label>
                      Marital Status <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Select
                      value={maritalStatusId}
                      onChange={(e) => {
                        handleDropdownChangeMarital(e);
                        setMaritalStatusError(
                          e.target.value ? "" : "Marital Status is required"
                        );
                      }}
                      className="form-control"
                    >
                      <option value="">Select Marital Status</option>
                      {maritalStatusesList.map((status) => (
                        <option
                          key={status.maritalStatusId}
                          value={status.maritalStatusId}
                        >
                          {status.maritalStatus}
                        </option>
                      ))}
                    </Form.Select>
                    {maritalStatusError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {maritalStatusError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formState">
                    <Form.Label>
                      State <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Select
                      value={stateId}
                      onChange={(e) => {
                        handleDropdownChangeState(e);
                        setStateError(
                          e.target.value ? "" : "State is required"
                        );
                      }}
                      className="form-control"
                    >
                      <option value="">Select State</option>
                      {stateList.map((status) => (
                        <option key={status.stateId} value={status.stateId}>
                          {status.stateName}
                        </option>
                      ))}
                    </Form.Select>
                    {stateError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {stateError}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="mb-3" controlId="formAddress">
                <Form.Label>
                  Street Address <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddress(value);
                    setAddressError(value ? "" : "Address is required");
                  }}
                />
                {addressError && (
                  <div style={{ color: "red", fontSize: "0.9em" }}>
                    {addressError}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPincode">
                <Form.Label>
                  Pin Code <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Pin Code"
                  value={pincode}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPinCode(value);
                    setPincodeError(value ? "" : "Pin Code is required");
                  }}
                />
                {pincodeError && (
                  <div style={{ color: "red", fontSize: "0.9em" }}>
                    {pincodeError}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formCategory">
                <Form.Label>
                  Category <b style={{ color: "red" }}>*</b>
                </Form.Label>
                <Form.Select
                  value={categoryId}
                  onChange={(e) => {
                    handleDropdownChangeCategory(e);
                    setCategoryError(
                      e.target.value ? "" : "Category is required"
                    );
                  }}
                  className="form-control"
                >
                  <option value="">Select Category</option>
                  {categoryList.map((status) => (
                    <option key={status.categoryId} value={status.categoryId}>
                      {status.patientCategory}
                    </option>
                  ))}
                </Form.Select>
                {categoryError && (
                  <div style={{ color: "red", fontSize: "0.9em" }}>
                    {categoryError}
                  </div>
                )}
              </Form.Group>

              {showTextbox && (
                <Form.Group className="mb-3" controlId="formOtherCategory">
                  <Form.Label>Specify Other Category</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter category"
                    value={othercategorytext}
                    onChange={(e) => {
                      const value = e.target.value;
                      setothercategorytext(value);
                      setOtherCategoryTextError(
                        value ? "" : "This field is required"
                      );
                    }}
                  />
                  {otherCategoryTextError && (
                    <div style={{ color: "red", fontSize: "0.9em" }}>
                      {otherCategoryTextError}
                    </div>
                  )}
                </Form.Group>
              )}

              {subcategoryList.length > 0 && (
                <Form.Group className="mb-3" controlId="formSubCategory">
                  <Form.Label>
                    Sub Category <b style={{ color: "red" }}>*</b>
                  </Form.Label>
                  <Form.Select
                    value={subCategoryId}
                    className="form-control"
                    onChange={(e) => {
                      handleDropdownChangeSubCategory(e);
                      setSubCategoryError(
                        e.target.value ? "" : "Sub Category is required"
                      );
                    }}
                  >
                    <option value="">Select Sub Category</option>
                    {subcategoryList.map((status) => (
                      <option
                        key={status.subCategoryId}
                        value={status.subCategoryId}
                      >
                        {status.patientSubCategory}
                      </option>
                    ))}
                  </Form.Select>
                  {subCategoryError && (
                    <div style={{ color: "red", fontSize: "0.9em" }}>
                      {subCategoryError}
                    </div>
                  )}
                </Form.Group>
              )}
              <center>
                <Button variant="primary" type="submit" onClick={handleSave}>
                  Submit
                </Button>&nbsp;&nbsp;
                <Button variant="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
              </center>
            </Form>
          </Card.Text>
        </Card.Body>
      </Card>
      <br />
      <ClientFooter />
    </div>
  );
};

export default PatientDetails;
